const getNewPersonField = (count: number) => ({
  role: count === 0 ? "partner" : "child",
  income: 0,
});

export default getNewPersonField;
